import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceByDeviceId } from '../../services/DeviceService';
import { Device } from '../../types/Devices';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDeviceByDeviceId(id: string, fleetId: string, enabled: boolean = true, refetch: boolean = true): UseQueryResult<Device> {
  return useQuery(
    ['device', id, fleetId],
    async (): Promise<Device> => getDeviceByDeviceId(id, fleetId),
    {
      retry: 3,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: refetch ? 4000 : false,
      enabled: !!id && enabled,
    },
  );
}

export default useGetDeviceByDeviceId;
